import StopScroll from "./StopScrollClass";
import JSHelpers from "./JSHelpersClass";

export default class Utils extends JSHelpers {

    /**
     * Tabs
     */
    tabsInit() {
        const speed = 200;

        let self = this,
            $tabs = document.getElementsByClassName('tabs_wrap');

        for (let i = 0; i < $tabs.length; i++) {
            let $menus = $tabs[i].getElementsByClassName('tab_menu')
            for (let i = 0; i < $menus.length; i++) {
                $menus[i].addEventListener("click", function() {
                    if(this.classList.contains('active')) return;

                    let $tabMenu = this,
                        dataID = this.getAttribute('data-id'),
                        $contentShow = document.getElementById(dataID);


                    //Add active class
                    $tabMenu.parentNode.getElementsByClassName('active')[0].classList.remove('active');
                    $tabMenu.classList.add('active');

                    //Siblings elements
                    let allSibling = self.getSiblings($contentShow.parentNode.childNodes);

                    //Move to opacity 0 all elements
                    for (let i = 0; i < allSibling.length; i++) {
                        if(allSibling[i].getAttribute('id') !== dataID) {
                            allSibling[i].classList.add('tab_fade_out');
                        }
                    }

                    //Start show new elements
                    setTimeout(function () {
                        for (let i = 0; i < allSibling.length; i++) {
                            if(allSibling[i].getAttribute('id') !== dataID) {
                                allSibling[i].style.display = 'none';
                                allSibling[i].classList.remove('tab_fade_out');
                            }
                        }

                        $contentShow.classList.add('tab_fade_in');
                        $contentShow.removeAttribute('style');

                        setTimeout(function () {
                            $contentShow.classList.remove('tab_fade_in');
                        }, speed);
                    }, speed - 20);
                });
            }
        }
    }

    /**
     * Toggles slide
     */
    toggleInit() {
        let $toggleWrap = document.getElementsByClassName('toggle-wrap');

        for (let i = 0; i < $toggleWrap.length; i++) {
            let $thisToggleWrap = $toggleWrap[i],
                $thisHeader = $thisToggleWrap.querySelectorAll('.toggle-wrap__header');

            for (let i = 0; i < $thisHeader.length; i++) {
                $thisHeader[i].addEventListener("click", function() {
                    if (this.classList.contains('active')) return;

                    let $thisTab = this;

                    //Remove all old active
                    let $oldActiveEl = $thisTab.parentNode.parentNode.querySelectorAll('.toggle-wrap__header.active');
                    for (let i = 0; i < $oldActiveEl.length; i++) {
                        $oldActiveEl[i].classList.remove('active');
                        $oldActiveEl[i].nextElementSibling.classList.remove('open');
                        $oldActiveEl[i].nextElementSibling.style.height = '0px';
                    }

                    $thisTab.classList.add('active');
                    $thisTab.nextElementSibling.classList.add('open');
                    let heightThisContent = $thisTab.nextElementSibling.firstElementChild.clientHeight;
                    $thisTab.nextElementSibling.style.height = heightThisContent + 'px';
                });
            }
        }
    }

    /**
     * Check webp
     * @returns {*}
     */
    supportsWebp() {
        if (!self.createImageBitmap) return false;

        const iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        if(iOS) return false;

        const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
        const blob = fetch(webpData).then(r => r.blob());
        if(createImageBitmap(blob).then(() => true, () => false)) {
            $('html').addClass('webp');
        } else {
            $('html').addClass('no-webp');
        }
    }

    /**
     * @param src
     * @param callback
     */
    callbackLoadScript(src, callback = null) {
        if(window.loadedScript && window.loadedScript.includes(src)) {
            if(callback) {
                callback();
            }
        } else {
            if(!window.loadedScript) {
                window.loadedScript = [src];
            } else {
                window.loadedScript.push(src);
            }

            let script = document.createElement('script');
            script.src = src;
            script.onload = () => {
                if(callback) {
                    callback()
                }
            };
            document.head.append(script);
        }
    }

    /**
     *
     * @param href
     * @param callback
     */
    callbackLoadStyle(href, callback) {
        if(window.loadedStyles && window.loadedStyles.includes(href)) {
            callback();
        } else {
            if(!window.loadedStyles) {
                window.loadedStyles = [href];
            } else {
                window.loadedStyles.push(href);
            }

            let link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.onload = () => {
                callback()
            };
            document.head.append(link);
        }
    }

    /**
     * https://github.com/aFarkas/lazysizes
     */
    lazy() {
        //if ('loading' in HTMLImageElement.prototype) {
        //TODO: load all images. Try nex time
        // const images = document.querySelectorAll('img[loading="lazy"]');
        // images.forEach(img => {
        //     img.src = img.dataset.src;
        // });
        //} else {
        //Dynamically import the LazySizes library
        // const script = document.createElement('script');
        // script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js';
        // document.body.appendChild(script);
        //}
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js';
        document.body.appendChild(script);
    }

}
